"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_PATH = '/leadin/v1/settings';
var CLIENT_TIMEOUT = 7000;

var MarketingFreeSettingsAPI =
/*#__PURE__*/
function () {
  function MarketingFreeSettingsAPI() {
    (0, _classCallCheck2.default)(this, MarketingFreeSettingsAPI);
  }

  (0, _createClass2.default)(MarketingFreeSettingsAPI, null, [{
    key: "get",
    value: function get() {
      return _apiClient.default.get(BASE_PATH, {
        query: {
          clienttimeout: CLIENT_TIMEOUT
        }
      });
    }
  }, {
    key: "update",
    value: function update(patch) {
      return _apiClient.default.patch(BASE_PATH, {
        data: patch,
        query: {
          clienttimeout: CLIENT_TIMEOUT
        }
      });
    }
  }]);
  return MarketingFreeSettingsAPI;
}();

exports.default = MarketingFreeSettingsAPI;
module.exports = exports.default;